import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'react-final-form';
import PropTypes from 'prop-types';
import { Box, Chip, Stack, Tooltip, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import ContentEditorFieldAdapter from 'components/shared/field-adapters/ContentEditorFieldAdapter';
import DatePickerFieldAdapter from 'components/shared/field-adapters/DatePickerFieldAdapter';
import SelectFieldAdapter from 'components/shared/field-adapters/SelectFieldAdapter';
import TextFieldAdapter from 'components/shared/field-adapters/TextFieldAdapter';
import { getLegalRoleOptions, getUiLanguageOptions } from 'common/constants/options';
import { isRequiredField } from 'common/utils/general';
import { LEGAL_TOKEN_REGISTRY, tokenLabel } from 'common/constants/legalTokens';

function LegalFields({ requiredFields }) {
  const { t } = useTranslation(['labels']);

  return (
    <Grid container spacing={4}>
      <Grid xs={12}>
        <Field
          id="title"
          name="title"
          component={TextFieldAdapter}
          label={t('title', { ns: 'labels' })}
          type="text"
          fullWidth
          required={isRequiredField('title', requiredFields)}
        />
      </Grid>
      <Grid xs={12}>
        <Field
          id="body"
          name="body"
          component={ContentEditorFieldAdapter}
          label={t('body', { ns: 'labels' })}
          required={isRequiredField('body', requiredFields)}
        />
      </Grid>
      <Grid xs={12} sx={{ mt: -2 }}>
        <Box sx={{ backgroundColor: 'surface.raised', border: '1px dashed', borderColor: 'hairline.strong', borderRadius: '12px', p: 2 }}>
          <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700, display: 'block', mb: 1 }}>
            {t('legalTokensHint', { ns: 'labels', defaultValue: 'Campos insertables: escribe el código en el documento. El cliente lo rellenará (autocompletado desde su perfil) y lo aceptará. Clic para copiar.' })}
          </Typography>
          <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', gap: 1 }}>
            {Object.keys(LEGAL_TOKEN_REGISTRY).map((key) => (
              <Tooltip key={key} title={tokenLabel(key, 'es')}>
                <Chip
                  label={`{{${key}}}`}
                  size="small"
                  onClick={() => { if (navigator.clipboard) navigator.clipboard.writeText(`{{${key}}}`); }}
                  sx={{ fontFamily: 'monospace', cursor: 'pointer' }}
                />
              </Tooltip>
            ))}
          </Stack>
        </Box>
      </Grid>
      <Grid xs={12} sm={4}>
        <Field
          id="created_at"
          name="created_at"
          component={DatePickerFieldAdapter}
          label={t('createdAt', { ns: 'labels' })}
          renderInputProps={{
            fullWidth: true,
            required: isRequiredField('created_at', requiredFields)
          }}
        />
      </Grid>
      <Grid xs={12} sm={4}>
        <Field
          id="role"
          name="role"
          component={SelectFieldAdapter}
          options={getLegalRoleOptions(t)}
          label={t('user', { count: 1, ns: 'labels' })}
          fullWidth
        />
      </Grid>
      <Grid xs={12} sm={4}>
        <Field
          id="language"
          name="language"
          component={SelectFieldAdapter}
          options={getUiLanguageOptions(t)}
          label={t('language', { count: 1, ns: 'labels' })}
          fullWidth
        />
      </Grid>
    </Grid>
  );
}

LegalFields.propTypes = {
  requiredFields: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default LegalFields;
